import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, postRequest, putRequest, deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon} from "../../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import { InfinitySpin } from  'react-loader-spinner';
import { DateTime } from "luxon";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { Avatar } from 'primereact/avatar';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { createDedupedAjaxRequest, extractSafePaginationParams, cleanSorters, parseSorters, parseMaskFilters, safeParse, refreshProgressiveFromStart } from '../../../utils/tabulatorProgressiveLoading';
import { getTabulatorPersistLayoutEvents } from '../../../utils/tabulatorPersistLayout';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';
const TRAINING_TEMPLATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'name': 'Common.Name',
  'department.name': 'TrainingTemplateList.Text.Oddelenie_sablony',
  'description': 'Common.Description',
  'id': 'Common.Name',
});


export default function TrainingTemplateList(){
const { t, locale } = useContext(LocaleContext);

    const [state,dispatch] = useContext(DatabaseContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter, openChosenNotificationPreferences} = useContext(UtilContext);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({'department.name':true,'training.department.name':true,'training.name':true});
    const [maskVisible, setMaskVisible] = useState(false);

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
const [editFormGauge, setEditFormGauge] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        const table = getTable();
        if (!table || !savedHScrollRef.current.pending) return;
        const holder = table.rowManager?.element;
        if (holder) holder.scrollLeft = savedHScrollRef.current.left;
        savedHScrollRef.current.pending = false;
    }, [getTable]);
    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

      function matchAny(data, filterParams) {
        //data - the data for the row being filtered
        //filterParams - params object passed to the filter
        //RegExp - modifier "i" - case insensitve
    
        var match = false;
        const regex = RegExp(filterParams.value, 'i');
    
        for (var key in data) {
            if (regex.test(data[key]) === true) {
                match = true;
            }
        }
        return match;
      }

      function searchTable() {
        setSearchIconColor("active");
        setVisibleSearch(false);
        refreshFromStart();
      }
    
        const accept = () => {
            let rows_to_delete = [];
            rows_to_delete = getTable()?.getSelectedData?.() ?? [];
            rows_to_delete.forEach(element => {
              console.log(element);
              deleteRequest(`/api/training_templates/${element.id}`)
                  .then((response) => {
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                  }).catch((reason) => {
                      alert(reason);
                      toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
                  })
            });
            refreshFromStart();
        }
    
        const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
        }
    
        const confirm = () => {
            confirmDialog({
                message: t('Common.ConfirmDeleteRecord'),
                header: t('Common.ConfirmDelete'),
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: t('Common.Yes'),
                rejectLabel: t('Common.No'),
                accept,
                reject
            });
        };
    
      const rowClick = (e, row) => {
        console.log(e, row);
     };
    
      const onSelectRow = (data, rows) => {
        setEditFormGauge(data);
          if(data.length === 0){
            setInsertIcon(true);
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
          else{
            setInsertIcon(false);
            setEditIcon(false);
            setCopyIcon(false);
            setDeleteIcon(false);
          }
      };

      function onEditRow(training_template){
        dispatch({type: 'create_new_tab', name: t('TaskTemplate.EditTemplate'), translationKey: 'TaskTemplate.EditTemplate', legacyLabel: t('TaskTemplate.EditTemplate'),page:'TrainingTemplateAdd',props:{training_template: training_template,type:'edit'},mask:'trng008'})
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }
      function DepartmentFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData.department ? rowData.department.name : "";
      }

      function CompanyFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData.training_company ? rowData.training_company.name : "";
      }

      function EmployeeFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData.employee ? rowData.employee.name : "";
      }

      const [draggingItem,setDraggingItem] = useState(null); 
      const [columns,setColumns] = useState([
        { title: '', field: 'id', formatter: "rowSelection", titleFormatter: "rowSelection", hozAlign: "center", width: 44, minWidth: 44, headerSort: false, resizable: false },
        { title: '', field: 'editor', hozAlign: "center", width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false },
        { title: t('Common.Name'), field: 'name', headerFilter: "input", minWidth: 200, widthGrow: 1 },
        { title: t('TrainingTemplateList.Text.Oddelenie_sablony'), field: 'department.name', headerFilter: "input", minWidth: 200, widthGrow: 1 },
        { title: t('Common.Description'), field: 'description', headerFilter: "input", minWidth: 200, widthGrow: 1 },
      ]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      if (searchValue != null && String(searchValue).trim() !== '') {
        extra.filter_search = String(searchValue).trim();
      }
      const table = getTable();
      const tableReadyForParams = tableBuiltRef.current;
      let hf = [];
      if (tableReadyForParams) hf = table?.getHeaderFilters?.() ?? [];
      if (tableReadyForParams && hf.length) {
        hf.forEach(f => {
          if (f?.field == null) return;
          const v = f.value;
          if (v === undefined || v === null || String(v).trim() === '') return;
          extra[`filter_${f.field}`] = v;
        });
      } else if (!tableReadyForParams && state.user_mask_filters) {
        const maskRow = state.user_mask_filters.find(m => m.page === 'TrainingTemplateList');
        if (maskRow) {
          parseMaskFilters(maskRow.filters).forEach(f => {
            if (!f?.field) return;
            const v = f.value;
            if (v === undefined || v === null || String(v).trim() === '') return;
            extra[`filter_${f.field}`] = v;
          });
        }
      }
      let sortersFromTable = [];
      if (tableReadyForParams) sortersFromTable = table?.getSorters?.() ?? [];
      const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
      if (hasSorters) {
        const clean = cleanSorters(sortersFromTable);
        if (clean.length > 0) extra.sorters = JSON.stringify(clean);
      } else if (!tableReadyForParams && state.user_mask_filters) {
        const maskRow = state.user_mask_filters.find(m => m.page === 'TrainingTemplateList');
        if (maskRow?.sorters) {
          const parsed = parseSorters(maskRow.sorters);
          if (parsed.length > 0) extra.sorters = JSON.stringify(parsed);
        }
      }
      return extra;
    }, [getTable, state.user_mask_filters, pageSizePc, searchValue]);

      const scrollToFirst = () => scrollToFirstUtil(getTable());
      const scrollUp = () => scrollUpUtil(getTable());
      const scrollDown = () => scrollDownUtil(getTable());
      const scrollToLast = () => scrollToLastUtil(getTable());

      function addNewTrainingType(){
        dispatch({type: 'create_new_tab', name: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'), translationKey: 'TrainingTemplateAdd.Text.Nova_sablona_skolenia', legacyLabel: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'),page:'TrainingTemplateAdd',props:{training_template: null,type:'add'},mask:'trng008'})
      }
      function copyTrainingType(){
        const sel = getTable()?.getSelectedData?.()?.[0];
        if (sel) dispatch({ type: 'create_new_tab', name: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'), translationKey: 'TrainingTemplateAdd.Text.Nova_sablona_skolenia', legacyLabel: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'), page: 'TrainingTemplateAdd', props: { training_template: sel, type: 'add' }, mask: 'trng008' });
      }
      function editTrainingType(){
        const sel = getTable()?.getSelectedData?.()?.[0];
        if (sel) dispatch({ type: 'create_new_tab', name: t('TrainingTemplateList.Text.Upravit_sablonu_skolenia'), translationKey: 'TrainingTemplateList.Text.Upravit_sablonu_skolenia', legacyLabel: t('TrainingTemplateList.Text.Upravit_sablonu_skolenia'), page: 'TrainingTemplateAdd', props: { training_template: sel, type: 'edit' }, mask: 'trng008' });
      }
    
      function handleDragStart(e, item){ 
        setDraggingItem(item);
        e.dataTransfer.setData('text/plain', ''); 
      }; 
  
      function handleDragEnd(){ 
        setDraggingItem(null);
      }; 
  
      function handleDragOver(e){ 
          e.preventDefault(); 
      }; 
  
      function handleDrop(e, targetItem){ 
          if (!draggingItem) return; 
  
          const currentIndex = columns.indexOf(draggingItem); 
          const targetIndex = columns.indexOf(targetItem); 
  
          if (currentIndex !== -1 && targetIndex !== -1) { 
            columns.splice(currentIndex, 1); 
            columns.splice(targetIndex, 0, draggingItem); 
             
          } 
          ref.current.setColumns(columns);
      }; 
    
    function setMask(item,value){
      const columnVisible = {...columnsVisible};
     columnVisible[item] = value;
     console.log(columnVisible);
      const table = getTable();
      for(const val in columnVisible) {
        if(columnVisible[val]==false){
          table?.hideColumn?.(`${val}`);
        }
        else{
          table?.showColumn?.(`${val}`);
        }
      }
      setColumnsVisible(columnVisible);
      setTimeout(() => {
        getTable()?.redraw?.(true);
      }, 0)
    }
  
    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );
  
    const [expandedKeys, setExpandedKeys] = useState({});
  
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
      }
    };
  
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const defaultColumnsVisible = {'department.name':true,'training.department.name':true,'training.name':true};
    const resetMask = () => resetTabulatorMask({ page: 'TrainingTemplateList', defaultColumnsVisible, ref, columns, setColumnsVisible });
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
              {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => { setUserMaskFilter("TrainingTemplateList", "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); refreshFromStart(); },
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => { setUserMaskFilter("TrainingTemplateList", "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => { setUserMaskFilter("TrainingTemplateList", "set_sorters", null, null, null, cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => { setUserMaskFilter("TrainingTemplateList", "set_sorters", null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingTemplateList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
      const columnVisible = {...columnsVisible};
        for(let val in columnVisible) {
          if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
            columnVisible[val]=value;
            ref.current.showColumn(`${val}`);
          }
        };
        setColumnsVisible(columnVisible);
        setTimeout(() => {
          ref.current.redraw(true);
        }, 0)
    }
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: TRAINING_TEMPLATE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

    
    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button onClick={() => addNewTrainingType()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editTrainingType()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyTrainingType()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button title={t('Common.Print')} onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button title={searchIconColor !== "active" ? t('Common.Search') : t('ServiceTask.CancelSearch')} onClick={searchIconColor !== "active" ? () => setVisibleSearch(true) : () => { setSearchIconColor(""); setSearchValue(""); refreshFromStart(); }}>{searchIconColor === "" ? <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" /> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" />}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button title={t('Common.ExportToExcel')} onClick={() => getTable()?.download?.("xlsx", "data.xlsx", { sheetName: "MyData" })}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button title={t('Icon.First')} onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button title={t('Icon.Previous')} onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button title={t('Icon.Next')} onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button title={t('Icon.Last')} onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button title={t('Common.AddToFavorites')} className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Common.TrainingCompanyList'),"TrainingTemplateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button title={t('Common.QuickView')} onClick={() => setFastView("TrainingTemplateList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    
    <div ref={elementRef}>
      <ReactTabulator
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        renderComplete: () => {
          restoreHScroll();
          if ((getTable()?.getSelectedData?.()?.length ?? 0) === 0) {
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
        },
        tableBuilt: () => {
          tableBuiltRef.current = true;
          const table = getTable();
          if (!table) return;
          const mask = state.user_mask_filters?.filter(m => m.page === "TrainingTemplateList") ?? [];
          if (mask.length > 0) {
            isRestoringRef.current = true;
            const attributes = safeParse(mask[0].attributes, []);
            const filters = parseMaskFilters(mask[0].filters);
            const sorters = parseSorters(mask[0].sorters);
            const json_columns = safeParse(mask[0].columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) {
              table.setColumnLayout?.(attributes);
            }
            if (json_columns && typeof json_columns === "object") {
              setColumnsVisible(json_columns);
              for (const column in json_columns) {
                if (json_columns[column] === false) table.hideColumn?.(column);
                else table.showColumn?.(column);
              }
            }
            if (Array.isArray(sorters) && sorters.length > 0) {
              table.setSort?.(sorters.map(s => ({ column: s.column ?? s.field, dir: s.dir })));
            }
            if (Array.isArray(filters) && filters.length > 0) {
              filters.forEach(f => table.setHeaderFilterValue?.(f.field, f.value ?? "", true));
            } else {
              table.clearHeaderFilter?.();
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
            refreshFromStart();
          }
        },
        ...getTabulatorPersistLayoutEvents("TrainingTemplateList", ref, setUserMaskFilter),
        headerFilterChanged: () => { if (!isRestoringRef.current) { captureHScroll(); refreshFromStart(); } },
        sortChanged: () => { if (!isRestoringRef.current) { captureHScroll(); refreshFromStart(); } },
      }}
      options={{
        renderHorizontal: "virtual",
        layout: "fitColumns",
        rowHeight: 30,
        movableColumns: true,
        headerSortTristate: true,
        ajaxURL: "/api/training_templates/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        filterMode: "remote",
        sortMode: "remote",
        pagination: false,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingEllipsis'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          return response;
        },
        ajaxError: () => {
          getTable()?.clearAlert?.();
        },
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.TrainingTemplateList'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: "active",
      }}/>
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                        draggable="true"
                        onDragStart={(e) =>  
                            handleDragStart(e, item)} 
                        onDragEnd={() => handleDragEnd()} 
                        onDragOver={(e) => handleDragOver(e)} 
                        onDrop={(e) => handleDrop(e, item)} 
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingTemplateList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      <Dialog visible={visibleLoading} style={{ width: '25vw',height:'25vh',backgroundColor: 'transparent',boxShadow: 'none'}} className='mypanel flex flex-row'  closable={false} draggable={false} showHeader={false}>
          <InfinitySpin 
          width='208'
          color="#000"
          />
          <p className='text-2xl font-bold text-center w-52 text-black'>{t('Common.LoadingEllipsis')}</p>
      </Dialog>
      
      </div> 
        </>
    )
}